import { Tooltip } from "@mui/material";

interface IProps {
  whatsappNumber: string;
}

const Whatsapp = ({ whatsappNumber }: IProps) => {
  return (
    <Tooltip title="Fale conosco!">
    <a
      href={`https://wa.me/${whatsappNumber}`}
      className="whats-icon animated fadeInRight delay-1s"
      target="_blank"
      rel="noreferrer"
    >
      <i className="lab la-fw la-whatsapp"></i>
    </a>
    </Tooltip>
  );
};

export default Whatsapp;
